import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { TAGS } from 'app/src/components/Tags/queries';
import minimalTable from 'app/src/elements/minimalTable';
import { Subtitle } from 'app/src/styles';
import { ActionText } from 'app/src/styles/table';

import NewMake from './new';

const baseColumns = [
  {
    key: 'serialNumber',
    label: 'Tag',
  },
  {
    key: 'dealer',
    label: 'Dealer',
    value: ({ value }) => value.label,
  },
  {
    key: 'make',
    label: 'Make',
    sort: 'asc',
  }
];

const UnknownMakes = ({ refetch }) => {
  const [showNew, setShowNew] = useState();

  const { data, refetch: refetchUnknown } = useQuery(TAGS, {
    variables: {
      limit: 1000,
      offset: window.btoa('0'),
      options: { scopes: ['ready_to_submit', 'unknown_make'] }
    },
    fetchPolicy: 'no-cache',
  });

  if (!data) { return null; }
  if (0 === data.tags.edges.length) { return null; }

  const tags = data.tags.edges.map(edge => edge.node);

  const columns = [
    ...baseColumns,
    {
      key: 'actions',
      label: 'Actions',
      sort: 'prevent',
      content: ({ entry }) => (
        <Pressable onPress={() => setShowNew({ label: entry.make })}>
          <ActionText>Setup</ActionText>
        </Pressable>
      ),
    },
  ];

  return (
    <View>
      <Subtitle>Ready to Submit Tags with Unknown Makes</Subtitle>

      <DataTable.Simple
        data={tags}
        columns={columns}
        pageLength="All"
      />

      {showNew && (
        <NewMake
          setShow={setShowNew}
          refetch={() => { refetch(); refetchUnknown(); }}
          {...showNew}
        />
      )}
    </View>
  );
};

export default UnknownMakes;
